import { render } from "./CpsNumberInput.vue?vue&type=template&id=54051cc2&ts=true"
import script from "./CpsNumberInput.vue?vue&type=script&lang=ts"
export * from "./CpsNumberInput.vue?vue&type=script&lang=ts"

import exportComponent from "/app/higgs.cps.portal.website/node_modules/.pnpm/vue-loader@16.8.3_f65c6e1beb608835961423903ad857fc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__